import React from 'react';
import MakeModelVariantSelectorModal from './MakeModelVariantSelectorModal';
// import './EntityField.scss';

class MakeModelVariantField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showMakeModelVariantSelector: false
    };

    this.onChange = this.onChange.bind(this);

    const titleParts = [];

    if (this.props.value.make !== undefined) {
      titleParts.push('merke');
    } else if (this.props.value.makes !== undefined) {
      titleParts.push('merker');
    }
    if (this.props.value.model !== undefined) {
      titleParts.push('modell');
    } else if (this.props.value.models !== undefined) {
      titleParts.push('modeller');
    }
    if (this.props.value.variant !== undefined) {
      titleParts.push('variant');
    } else if (this.props.value.variants !== undefined) {
      titleParts.push('varianter');
    }


    // Old browser fallback
    this.title = 'Merke, modell og variant';

    if (Intl && Intl.ListFormat) {
      const lf = new Intl.ListFormat('nb');
      this.title = lf.format(titleParts);
    }
  }

  onChange(...values) {
    this.setState({
      showMakeModelVariantSelector: false
    });
    this.props.onChange(...values);
  }

  render() {
    const entity = this.props.value;

    const cls = this.props.cls || 'info';

    return (
      <div className={`${this.props.disabled ? 'disabled ' : ''}contentful-entity-field`}>
        <div className="contentful-entity">
          <div className="contentful-entity-toolbar">
            <div className={`contentful-entity-header alert-${cls}`} title={this.title} >
              <strong className="text-capitalize">{this.title}</strong>
            </div>
            <div className="contentful-entity-title">
              {entity.make !== undefined &&
                <div>
                  {entity.make && <h3>{entity.make.name || entity.make.title}</h3>}
                  {!entity.make && <h3 className="text-muted">Ingen merke</h3>}
                </div>
              }
              {entity.makes !== undefined &&
                <div>
                  {entity.makes && entity.makes.length > 0 && <h3>{(entity.makes.map((m) => m.name || m.title)).join(', ')}</h3>}
                  {(!entity.makes || !entity.makes.length) && <h3 className="text-muted">Ingen merker</h3>}
                </div>
              }

              {entity.model !== undefined &&
                <div>
                  {entity.model && <h4>{entity.model.name || entity.model.title}</h4>}
                  {!entity.model && <h4 className="text-muted">Ingen modell</h4>}
                </div>
              }
              {entity.models !== undefined &&
                <div>
                  {entity.models && entity.models.length > 0 && <h4>{(entity.models.map((m) => m.name || m.title)).join(', ')}</h4>}
                  {(!entity.models || !entity.models.length) && <h4 className="text-muted">Ingen modeller</h4>}
                </div>
              }

              {entity.variant !== undefined &&
                <div>
                  {entity.variant && <span>{entity.variant.name || entity.variant.title}</span>}
                  {!entity.variant && <span className="text-muted">Ingen variant</span>}
                </div>
              }
              {entity.variants !== undefined &&
                <div>
                  {entity.variants && entity.variants.length > 0 && (entity.variants.map((lvl, i) => <span key={i} className="span-list-item">{lvl.name || lvl.title}</span>))}
                  {(!entity.variants || !entity.variants.length) && <span className="text-muted span-list-item">Ingen varianter</span>}
                </div>
              }
            </div>
            <div className="contentful-entity-actions text-right">
              <a
                className={`${(this.state.showMakeModelVariantSelector ? 'active ' : '') + (this.props.disabled ? 'disabled ' : '')}btn btn-default`}
                onClick={() => this.setState({showMakeModelVariantSelector: true})}
              >
                <i className="fa fa-pencil" aria-hidden="true"></i> Endre
              </a>
            </div>
          </div>
        </div>

        <MakeModelVariantSelectorModal
          show={this.state.showMakeModelVariantSelector}
          onChange={this.onChange}
          onHide={() => this.setState({showMakeModelVariantSelector: false})}
          make={entity.make}
          makes={entity.makes}
          model={entity.model}
          models={entity.models}
          variant={entity.variant}
          variants={entity.variants}
          showArchivedModels={this.props.showArchivedModels}
        />
      </div>
    );
  }
}

MakeModelVariantField.defaultProps = {
  values: {},
  name: 'entity',
  disabled: false,
  onChange: () => {}
};

export default MakeModelVariantField;
